import { NzTabComponent } from 'ng-zorro-antd/tabs';

/** The part of NG-ZORRO's tab this file changes. */
interface Tab {
  isActive: boolean;
  hasBeenActive: boolean;
  setActive(active: boolean): void;
}

/**
 * Renders only the content of the active tab, as NG-ZORRO 16 did (feature 024, hops 17 and 18).
 *
 * Since NG-ZORRO 17 a tab's content stays rendered once it has been active and is only hidden. Components in the
 * portal's tabs were written for the old behavior: leaving a tab destroyed them. Kept alive, the hidden copies answer
 * `@ViewChild` queries in place of the visible ones and keep their subscriptions open. NG-ZORRO 18 renders a tab when
 * it is selected or `hasBeenActive`, and sets that flag in `setActive`, which the tab set calls on every tab when the
 * selection changes; following `active` there restores the old rule, and `nzForceRender` keeps working.
 * `nzDestroyInactiveTabPane` (NG-ZORRO 18) does the same per tab set, but cannot be set globally.
 *
 * Called once before bootstrap. Review it on every NG-ZORRO upgrade: `setActive` and `hasBeenActive` are not
 * documented API.
 */
export function renderOnlyActiveTab(prototype: Tab = NzTabComponent.prototype as unknown as Tab): void {
  prototype.setActive = function (this: Tab, active: boolean) {
    this.isActive = active;
    this.hasBeenActive = active;
  };
}
